import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { CheckboxValueChangeEvent } from './checkbox.types';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {
  @Input() checked: boolean = false;
  @Input() id!: number;
  @Input() i18nLabel!: string;
  @Input() rightSlotTemplate: TemplateRef<any> | undefined;

  @Output() valueChange = new EventEmitter<CheckboxValueChangeEvent>();

  constructor() {}

  ngOnInit() {
    return;
  }

  onChangeState(): void {
    this.valueChange.next({
      checked: !this.checked,
      id: this.id,
    });
  }
}
